import React, {useState} from 'react'
import {ErrorMessage, Field, Formik} from 'formik'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'

const CustomerIsAnInternalRank = () => {
  const [count, setCount] = useState(0)

  const handleAddCustomerIsInternal = (event: any) => {
    event.preventDefault()
    if (count < 2) {
      setCount(count + 1)
    }
  }

  const handleRemoveCustomerIsInternal = (event: any) => {
    event.preventDefault()
    if (count > 0) {
      setCount(count - 1)
    }
  }

  return (
    <>
      <div>
        {[...Array(count + 1)].map((_, index) => (
          <div key={index}>
            <div className='d-flex align-items-center'>
              {index > 0 && (
                <>
                  <h5 className='fw-bolder text-ms m-0 mt-4'>Thông tin công ty {index + 1}</h5>
                  <button
                    className='bg-transparent border-0 mt-3'
                    onClick={handleRemoveCustomerIsInternal}
                  >
                    <img
                      className=''
                      alt='metronic'
                      src={toAbsoluteUrl('/media/nhsv/minus-circle.png')}
                    />
                  </button>
                </>
              )}
            </div>
            <div className='mt-4'>
              <Field
                name={`internal_cpny_nm_${index + 1}`}
                placeholder='Tên công ty*'
                className='form-control form-control-lg form-control-solid'
              />
              <div className='text-danger mt-2'>
                <ErrorMessage component='span' name='internal_cpny_nm_1' />
              </div>
            </div>
            <div className='mt-4'>
              <Field
                name={`internal_stk_${index + 1}`}
                placeholder='Mã chứng khoán*'
                className='form-control form-control-lg form-control-solid'
              />
              <div className='text-danger mt-2'>
                <ErrorMessage component='span' name='internal_stk_1' />
              </div>
            </div>
            <div className='mt-4'>
              <Field
                name={`internal_position_${index + 1}`}
                placeholder='Chức vụ*'
                className='form-control form-control-lg form-control-solid'
              />
              <div className='text-danger mt-2'>
                <ErrorMessage component='span' name='internal_position_1' />
              </div>
            </div>
          </div>
        ))}
      </div>
      {count < 1 && (
        <div className='mt-6'>
          <button
            className='d-flex align-items-center bg-transparent border-0'
            onClick={handleAddCustomerIsInternal}
          >
            <img className='' alt='metronic' src={toAbsoluteUrl('/media/nhsv/add-circle.png')} />
            <div className='fw-bolder text-primary mx-2'>Thêm thông tin công ty</div>
          </button>
        </div>
      )}
    </>
  )
}

export default CustomerIsAnInternalRank
